/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CreateUserContactResponse
 */
export interface CreateUserContactResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof CreateUserContactResponse
     */
    userContactId: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the CreateUserContactResponse interface.
 */
export function instanceOfCreateUserContactResponse(value: object): value is CreateUserContactResponse {
    if (!('userContactId' in value) || value['userContactId'] === undefined) return false;
    return true;
}

export function CreateUserContactResponseFromJSON(json: any): CreateUserContactResponse {
    return CreateUserContactResponseFromJSONTyped(json, false);
}

export function CreateUserContactResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUserContactResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userContactId': ApiUserTasksGetPageParameterFromJSON(json['userContactId']),
    };
}

export function CreateUserContactResponseToJSON(json: any): CreateUserContactResponse {
    return CreateUserContactResponseToJSONTyped(json, false);
}

export function CreateUserContactResponseToJSONTyped(value?: CreateUserContactResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userContactId': ApiUserTasksGetPageParameterToJSON(value['userContactId']),
    };
}

